<template>
  <div class="nodata">
    <van-loading v-if="show" color="#0294FF" vertical>加载中...</van-loading>
    <div v-else>
      <van-image  :src="require('../assets/nopro.png')"/>
      <div>暂无数据</div>
    </div>
  </div>
</template>
<script>
import { Image as VantImage, Loading } from 'vant'
export default {
  name: 'NoData',
  data() {
    return {
      show: true
    }
  },
  created() {
    setTimeout(() => {
      this.show = false
    },500)
  },
  components: {
    [VantImage.name]: VantImage,
    [Loading.name]: Loading
  }
}
</script>